import React from 'react';
import HeroMetric from './HeroMetric';
import SecondaryMetrics from './SecondaryMetrics';

const DashboardHeader = ({ stats, trends }) => {
  const months = trends?.months || [];

  const memberSparkline = months.map(m => ({ value: m.activeMembers }));
  const contributionSparkline = months.map(m => ({ value: m.totalCollected }));
  const rateSparkline = months.map(m => ({ value: m.collectionRate }));

  return (
    <div className="space-y-4 mb-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <HeroMetric
          title="Active Members"
          value={stats.totalMembers || 0}
          sparklineData={memberSparkline}
          format="number"
          color="blue"
          subtitle={stats.activeFamilyMembers ? `${stats.activeFamilyMembers.toLocaleString()} family members` : undefined}
        />
        <HeroMetric title="Monthly Contributions" value={stats.monthlyContributions || 0} sparklineData={contributionSparkline} format="currency" color="green" />
        <HeroMetric title="Collection Rate" value={stats.collectionRate || 0} sparklineData={rateSparkline} format="percent" color="purple" />
        <HeroMetric
          title="Year to Date"
          value={stats.ytdTotal || 0}
          format="currency"
          color="orange"
          subtitle={stats.ytdPaymentCount ? `${stats.ytdPaymentCount.toLocaleString()} payments` : undefined}
        />
      </div>
      <SecondaryMetrics stats={stats} />
    </div>
  );
};

export default DashboardHeader;
